import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { qaApi } from "../../../services/api/qaApi";
import { formatDistanceToNow } from "date-fns";
import { FiAward, FiMessageCircle, FiEye } from "react-icons/fi";
import "./widgets.css";

const BountyQuestions = ({ onQuestionClick }) => {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBountyQuestions();
  }, []);

  const loadBountyQuestions = async () => {
    try {
      setLoading(true);
      const response = await qaApi.getBountyQuestions(10);

      if (response.data.success) {
        setQuestions(response.data.questions || []);
      }
    } catch (error) {
      // Silent fail - widget is not critical
    } finally {
      setLoading(false);
    }
  };

  const handleQuestionClick = (questionId) => {
    if (onQuestionClick) {
      onQuestionClick(questionId);
    } else {
      navigate(`/posts/${questionId}`);
    }
  };

  if (loading) {
    return (
      <div className="cbx-widget cbx-widget--bounty">
        <div className="cbx-widget__header">
          <h3 className="cbx-widget__title">
            <FiAward className="cbx-widget__title-icon" />
            Active Bounties
          </h3>
        </div>
        <div className="cbx-widget__loading">Loading...</div>
      </div>
    );
  }

  if (questions.length === 0) {
    return (
      <div className="cbx-widget cbx-widget--bounty">
        <div className="cbx-widget__header">
          <h3 className="cbx-widget__title">
            <FiAward className="cbx-widget__title-icon" />
            Active Bounties
          </h3>
        </div>
        <div className="cbx-widget__empty">
          <FiAward className="cbx-widget__empty-icon" />
          <p className="cbx-widget__empty-text">
            No active bounties at the moment!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="cbx-widget cbx-widget--bounty">
      <div className="cbx-widget__header">
        <h3 className="cbx-widget__title">
          <FiAward className="cbx-widget__title-icon" />
          Active Bounties
        </h3>
        <Link to="/questions/bounty" className="cbx-widget__see-all">
          See All
        </Link>
      </div>

      <div className="cbx-bounty-list">
        {questions.slice(0, 3).map((question) => {
          const bounty = question.question?.bounty || 0;
          const answerCount = question.question?.answers?.length || 0;
          const views = question.question?.views || 0;

          return (
            <div
              key={question._id}
              className="cbx-bounty-item"
              onClick={() => handleQuestionClick(question._id)}
            >
              <span className="cbx-bounty-badge">
                <FiAward />
                +{bounty}
              </span>

              <div className="cbx-bounty-content">
                <h4 className="cbx-bounty-title">
                  {question.question?.title || "Question"}
                </h4>

                {question.question?.tags &&
                  question.question.tags.length > 0 && (
                    <div className="cbx-bounty-tags">
                      {question.question.tags.slice(0, 2).map((tag, idx) => (
                        <span key={idx} className="cbx-bounty-tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}

                <div className="cbx-bounty-meta">
                  <span className="cbx-bounty-stat">
                    <FiMessageCircle />
                    {answerCount}
                  </span>
                  <span className="cbx-bounty-stat">
                    <FiEye />
                    {views}
                  </span>
                  <span className="cbx-bounty-time">
                    {formatDistanceToNow(new Date(question.createdAt), {
                      addSuffix: true,
                    })}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BountyQuestions;
